import React from 'react';
import { connect } from 'react-redux';
import ReactEcharts from '../lazy/Echarts';
import { getIngestStatsForBuilding } from '../../redux/selectors/ingestStats';
import { dateTime, graphDateString } from '../../utils/parsing';
import { zip } from '../../utils/collections';
import { ECHARTS_COLORS } from '../../redux/constants/colors';

const getOption = ({ building, labels, series, timestamps, latest }) => ({
  title: {
    text: `${building.name} - Ingest Stats`,
    subtext: `Last processed @ ${dateTime(latest)}`,
  },
  tooltip: {
    trigger: 'axis',
  },
  legend: {
    type: 'scroll',
    orient: 'horizontal',
    data: labels,
    top: '90%',
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '10%',
    containLabel: true,
  },
  xAxis: {
    type: 'time',
    boundaryGap: false,
    data: timestamps,
  },
  yAxis: [
    {
      type: 'value',
      position: 'left',
    },
    {
      type: 'value',
      position: 'right',
      name: 'ms',
    },
  ],
  color: ECHARTS_COLORS,
  series,
});

/**
 * A graph of building ingest stats for the selected interval
 */
const BuildingIngestGraph = (props) => {
  if (props.isEmpty) return null;
  return <ReactEcharts option={getOption(props)} notMerge />;
};

export default connect((state, { building }) => {
  const {
    entities: {
      ingestStats: { latestTimestamps },
    },
  } = state;
  const stats = getIngestStatsForBuilding(state, building.id);
  const timestamps = stats.map((s) => graphDateString(s.timestamp));
  const makeData = (prop) =>
    zip(
      timestamps,
      stats.map((s) => s[prop])
    );
  const series = [
    { name: '# Points', type: 'line', data: makeData('num_points') },
    { name: '# Info Messages', type: 'line', data: makeData('infos') },
    { name: '# Error Messages', type: 'line', data: makeData('errors') },
    {
      name: 'Processing Time (ms)',
      type: 'line',
      yAxisIndex: 1, // values are much larger, use a separate axis
      symbol: 'none',
      data: makeData('processing_time_ms'),
    },
  ];
  const labels = series.map((s) => s.name);
  return {
    labels,
    series,
    timestamps,
    isEmpty: stats.length === 0,
    latest: latestTimestamps[building.id],
  };
})(BuildingIngestGraph);
